import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../components/Loader";

const PrivateRoute = ({ children }) => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_PUBLIC_URL}/api/v1/user-status`,
          {
            credentials: "include",
          },
        );

        const data = await res.json();
        console.log({ data });
        if (data?.success === 1) {
          setStatus("authenticated");
        } else {
          setStatus("unauthenticated");
        }
      } catch (e) {
        console.error("Auth check error:", e);
        setStatus("unauthenticated");
      }
    };

    checkAuth();
  }, [languageType]);

  // ⏳ Still fetching
  if (status === "loading") return <Loader />;

  // ❌ Not logged in → redirect to Drupal login
  if (status === "unauthenticated") {
    window.location.href = "https://neepco.co.in/neepco/user/login";
    return null;
  }

  // ✅ Logged in
  return children;
};

export default PrivateRoute;
